import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const ClockCheckIcon = ({
  width = 16,
  fill = '#334155',
  height = 16
}: SVGComponentProps) => (
  <SVGUniqueID>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_733_5275)">
        <path
          d="M9.66683 12.6673L11.0002 14.0007L14.0002 11.0007M14.6569 8.36724C14.6635 8.24588 14.6668 8.12365 14.6668 8.00065C14.6668 4.31875 11.6821 1.33398 8.00016 1.33398C4.31826 1.33398 1.3335 4.31875 1.3335 8.00065C1.3335 11.6243 4.2245 14.5726 7.82582 14.6651M8.00016 4.00065V8.00065L10.4924 9.24677"
          stroke={fill}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_733_5275">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { ClockCheckIcon };
